import logoMark from '../../assets/brand/reli-logo-circle.svg';
import './Logo.css';

function Logo() {
  return (
    <a className="logo" href="/" aria-label="RELI home">
      <img className="logo-mark" src={logoMark} alt="" aria-hidden="true" />
      <span>RELI</span>
    </a>
  );
}

export default Logo;
